import { render, staticRenderFns } from "./AdminCampaignItemPaymentActions.vue?vue&type=template&id=8ae68708&"
import script from "./AdminCampaignItemPaymentActions.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignItemPaymentActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports